"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const List_1 = tslib_1.__importDefault(require("@mui/material/List"));
const InternalConstants_1 = require("../../PageLayout/InternalConstants");
const IconComponent_1 = tslib_1.__importDefault(require("../IconComponent"));
const ArgusMenuComponentSwitch_1 = tslib_1.__importDefault(require("./ArgusMenuComponentSwitch"));
const StyledComponents_1 = require("./StyledComponents");
const useLocalStorage_1 = require("./useLocalStorage");
const ArgusMenuDrawer = ({ children, config, ...rest }) => {
    const [open, setOpen] = (0, useLocalStorage_1.useLocalStorage)("menuDrawerOpen", false);
    return (React.createElement(Box_1.default, { display: "flex", ...rest?.WrapperProps },
        React.createElement(StyledComponents_1.Drawer, { variant: "permanent", open: open, ...rest?.DrawerProps },
            React.createElement(List_1.default, { sx: { mx: 2 } },
                React.createElement(ArgusMenuComponentSwitch_1.default, { ...{ open, items: config?.items } })),
            React.createElement(StyledComponents_1.DrawerFooter, { open: open },
                React.createElement(StyledComponents_1.ToggleButton, { onClick: () => setOpen(!open) },
                    React.createElement(IconComponent_1.default, { iconId: open ? "menuClosed" : "menuOpen", sx: { border: `1px solid ${StyledComponents_1.DARK_TEXT_SECONDARY}`, borderRadius: "4px" } })))),
        React.createElement(Box_1.default, { sx: {
                flexGrow: 1,
                /**
                 * The styling below manipulates the CSS in the PageLayout components.
                 * By applying the styling here, we can keep compatibility for both the new and old menu without major refactoring of PageLayout
                 * Once the beta is done, this styling should be moved to the PageLayout components directly.
                 */
                ".MnePageLayoutWrapper": {
                    height: "unset",
                    width: `calc(100vw - ${open ? StyledComponents_1.MENU_WIDTH_OPEN : StyledComponents_1.MENU_WIDTH_CLOSED}px)`,
                    transition: (theme) => (open ? (0, StyledComponents_1.enterTransition)(theme) : (0, StyledComponents_1.leaveTransition)(theme)),
                    marginTop: 0,
                },
                ".MneInnerContainerMainContent": {
                    height: `calc(100vh - ${InternalConstants_1.PAGE_HEADER_HEIGHT}px)`,
                },
                ".MneSidebar": {
                    height: `calc(100vh - ${InternalConstants_1.PAGE_HEADER_HEIGHT}px)`,
                },
            } }, children)));
};
exports.default = ArgusMenuDrawer;
